import Constants from 'constants.js';
import Dispatcher from 'core/Dispatcher';
// Services
import AccountService from 'services/AccountService';
import ItemService from 'services/ItemService';
// Actions
import AlertAction from 'actions/AlertAction';
// Locales
import translate from 'locales/i18n';
import Facade from 'core/Facade';

class ItemAction {

    addCategoryIdToItems = (items, categories) => {
        const itemsWithCategoryId = items.map(item => {
            let categoryId = '';

            if (item.category) {
                categoryId = categories.find(category => category.name === item.category).id;
            } else {
                categoryId = '5cb9754894ede413bc253a12'; // Add the default category id or create a way to get it dynamicly
            }

            // We need to create new object to avoid side effect
            const newItem = Object.assign({}, item);
            return Object.assign(newItem, { 'category_id': categoryId });
        });
        return itemsWithCategoryId;
    };

    addItems(items, categoriesAdded, categoriesToAdd, accountId) {
        Dispatcher.dispatch({
            actionType: Constants.ADD_ITEMS_START,
        });

        if (categoriesToAdd.length > 0) {
            AccountService.addCategories(categoriesToAdd, accountId).then(categories => {
                ItemService.addItems(this.addCategoryIdToItems(items, categoriesAdded.concat(categories)), accountId).then(() => {
                    Dispatcher.dispatch({
                        actionType: Constants.ADD_ITEMS_END,
                    });
                    AlertAction.open('success', translate.i18n('SUCCESS_IMPORT_ACCOUNT'), 'top-right');
                }, () => {
                    AlertAction.open('error', translate.i18n('ERROR_IMPORT_ACCOUNT'), 'top-right');
                });
            }, () => {
                AlertAction.open('error', translate.i18n('ERROR_ADD_CATEGORY'), 'top-right');
            });
        } else {
            ItemService.addItems(this.addCategoryIdToItems(items, categoriesAdded), accountId).then(() => {
                Dispatcher.dispatch({
                    actionType: Constants.ADD_ITEMS_END,
                });
                AlertAction.open('success', translate.i18n('SUCCESS_IMPORT_ACCOUNT'), 'top-right');
            }, () => {
                AlertAction.open('error', translate.i18n('ERROR_IMPORT_ACCOUNT'), 'top-right');
            });
        }
    }

    diffImportItems(keys, items, accountId) {
        Dispatcher.dispatch({
            actionType: Constants.DIFF_IMPORT_ITEMS_START,
        });

        ItemService.diffImportItems(keys, items, accountId).then(data => {
            Dispatcher.dispatch({
                actionType: Constants.DIFF_IMPORT_ITEMS_END,
                value: Facade.keysToCamel(data)
            });
        });
    }

    execImportItems(keys, values, items, articleRules, attributesRules, accountId) {
        Dispatcher.dispatch({
            actionType: Constants.EXEC_IMPORT_ITEMS_START,
        });

        return ItemService.execImportItems(keys, values, items, articleRules, attributesRules, accountId)
            .then(data => {
                Dispatcher.dispatch({
                    actionType: Constants.EXEC_IMPORT_ITEMS_END,
                    value: Facade.keysToCamel(data)
                });
            }, err => {
                throw err;
            });
    }

    importAdditionalDatas(items, accountId) {
        Dispatcher.dispatch({
            actionType: Constants.EXEC_IMPORT_ADDITIONAL_DATAS_START,
        });

        return ItemService.importAdditionalDatas(items, accountId)
            .then(data => {
                Dispatcher.dispatch({
                    actionType: Constants.EXEC_IMPORT_ADDITIONAL_DATAS_END,
                    value: Facade.keysToCamel(data)
                });
                return true;
            }, () => {
                Dispatcher.dispatch({
                    actionType: Constants.EXEC_IMPORT_ADDITIONAL_DATAS_ERROR
                });
                return false;
            });
    }
}

export default new ItemAction();
